<template>
	<div class="manager-container" :class="'manager-container-' + currentPage + ' ' + (currentPage === 'results' ? 'container-fluid' : 'container')">
		<manager-login-view v-if="currentPage === 'login'" />
		<manager-section-view v-else-if="currentPage === 'section'" />
		<manager-control-panel-view v-else-if="currentPage === 'control-panel'" />
		<manager-results-view v-else-if="currentPage === 'results'" />
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import { mapGetters } from 'vuex'

	import ManagerLoginView from './manager/00-Login';
	import ManagerSectionView from './manager/01-Section';
	import ManagerControlPanelView from './manager/02-ControlPanel';
	import ManagerResultsView from './manager/03-Results';

	const pageComponentDefault = 'login';

	export default {
		name: 'manager-view',
		components: {
			ManagerLoginView,
			ManagerSectionView,
			ManagerControlPanelView,
			ManagerResultsView,
		},
		computed: {
			currentPage() {
				let page = this.$route.meta.childPage;

				if (typeof(page) !== 'string' || page === '') {
					page = pageComponentDefault;
				}

				return page;
			},
		},
	}
</script>

<style lang="scss" scoped>
	.manager-container {
		min-width: 575px;
	}
</style>
